import { UserRole } from "../../../app/userSlice";
import { ReportLevel } from "./adminReportsApiSlice";

export const barAndLineChartColors = ["#5470c6", "#91cc75", "#d97706"]; // bar 1, bar 2, line
export const threeBarAndLineChartColors = ["#5470c6", "#14b8a6", "#91cc75", "#d97706"]; //bar 1, bar 2, bar 3, line
export const traitChartColors = [
	"#93C5FD", // Blue (Development of Ideas)
	"#D8B4FE", // Purple (Organization)
	"#F472B6", // Pink (Style)
	"#FDBA74", // Orange (Word Choice)
	"#FCD34D", // Yellow (Sentence Fluency)
	"#6EE7B7", // Green (Conventions)
	"#CBD5E1", // Total Score
];

export const getReportLevel = (districtId?: number, schoolId?: number): ReportLevel => {
	if (districtId && schoolId) {
		return ReportLevel.School;
	} else if (districtId) {
		return ReportLevel.District;
	} else {
		return ReportLevel.State;
	}
};

export const getMaxReportLevel = (role: UserRole | null): ReportLevel => {
	switch (role) {
		case UserRole.Admin:
		case UserRole.StateAdmin:
			return ReportLevel.State;
		case UserRole.DistrictAdmin:
			return ReportLevel.District;
		case UserRole.SchoolAdmin:
			return ReportLevel.School;
		default:
			return ReportLevel.Course;
	}
};

export const reportSubLevelName = (level: ReportLevel): string => {
	switch (level) {
		case ReportLevel.State:
			return "District";
		case ReportLevel.District:
			return "School";
		case ReportLevel.School:
			return "Course";
		default:
			return "";
	}
};

export interface BuildQueryStringParams {
	districtFilter?: number;
	schoolFilter?: number;
	yearFilter?: string;
	draftTypeFilter?: number | null;
	genreFilter?: number;
	traitFilter?: number;
	promptFilter?: number;
	categoryFilter?: number;
}

export const buildReportQueryString = (params: BuildQueryStringParams): string => {
	const urlParams = new URLSearchParams();

	if (params.districtFilter && params.districtFilter !== 0) {
		urlParams.append("districtId", String(params.districtFilter));
	}

	if (params.schoolFilter && params.schoolFilter !== 0) {
		urlParams.append("schoolId", String(params.schoolFilter));
	}

	if (params.yearFilter) {
		urlParams.append("schoolYear", params.yearFilter);
	}

	if (params.traitFilter && params.traitFilter !== 0) {
		urlParams.append("scoreCategoryId", String(params.traitFilter));
	}

	if (params.genreFilter && params.genreFilter !== 0) {
		urlParams.append("genreId", String(params.genreFilter));
	}

	if (params.draftTypeFilter && params.draftTypeFilter !== 0) {
		urlParams.append("draftStatus", String(params.draftTypeFilter));
	}

	if (params.promptFilter) {
		urlParams.append("promptId", String(params.promptFilter));
	}

	if (params.categoryFilter && params.categoryFilter !== 0) {
		urlParams.append("tutorialCategoryId", String(params.categoryFilter));
	}

	return urlParams.toString();
};
